
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">
            Klaverundervisning for alle
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Fleksible undervisningsmuligheder tilpasset dine behov, mål og niveau.
          </p>
          <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
            <Link to="/kontakt#top">Book Gratis Prøvetime</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
